const orderGrid = {
    orderGridEletricity: function (data) {
        var germany = [];
        var netherlands = [];
        var france = [];
        var italy = [];
        var belgium = [];
        var austria = [];
        var spain = [];
        var czechRep = [];
        var slovakia = [];
        var hungary = [];
        var nordics = [];
        var switzerland = [];
        var uk = [];
        var poland = [];
        var restOfWorld = [];
        const restOfWorldMap = new Map();
        let states = ["Germany", "Netherlands", "France", "Italy", "Belgium", "Austria", "Spain", "Czech Rep.", "Slovakia", "Hungary", "Switzerland", "Poland", "United-Kingdom"];

        for (var i = 0; i < data.length; i++) {
            if (data[i].state == "Germany") {
                germany = data[i];
            }
            if (data[i].state == "Netherlands") {
                netherlands = data[i];
            }

            if (data[i].state == "France") {
                france = data[i];
            }

            if (data[i].state == "Italy") {
                italy = data[i];
            }
            if (data[i].state == "Belgium") {
                belgium = data[i];
            }
            if (data[i].state == "Austria") {
                austria = data[i];
            }
            if (data[i].state == "Spain") {
                spain = data[i];
            }
            if (data[i].state == "Czech Rep.") {
                czechRep = data[i];
            }
            if (data[i].state == "Slovakia") {
                slovakia = data[i];
            }
            if (data[i].state == "Hungary") {
                hungary = data[i];
            }
            if (data[i].state == "Switzerland") {
                switzerland = data[i];
            }
            if (data[i].state == "Poland") {
                poland = data[i];
            }
            if (data[i].state == "United-Kingdom") {
                uk = data[i];
            }
            else {
                if (!states.includes(data[i].state)) {
                    if (restOfWorldMap.has(data[i].priceAreaName)) {
                        restOfWorldMap.delete(data[i].priceAreaName);
                        restOfWorldMap.set(data[i].priceAreaName, data[i]);
                    } else {
                        restOfWorldMap.set(data[i].priceAreaName, data[i]);
                    }
                }
            }
        }
        restOfWorld = Array.from(restOfWorldMap.values());
        restOfWorld.sort(function (a, b) {
            let x = a.state.toLowerCase();
            let y = b.state.toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0; });
        var list = [uk, germany, netherlands, france, italy, belgium, austria, spain, czechRep, slovakia, hungary, switzerland, poland, ...restOfWorld];
        let output = list.filter(obj => Object.keys(obj).includes("state"));
        return output;

    }
}

export default orderGrid;